import config from "@/config";

let sessionEnabled = false;

export function isMachineTranslationPreviewEnvironmentAllowed(): boolean {
  return config.translations.machinePreviewAllowed;
}

export function setMachineTranslationPreviewSessionEnabled(
  enabled: boolean
): void {
  if (!enabled) {
    sessionEnabled = false;
    return;
  }

  sessionEnabled = isMachineTranslationPreviewEnvironmentAllowed();
}

export function isMachineTranslationPreviewActive(): boolean {
  return isMachineTranslationPreviewEnvironmentAllowed() && sessionEnabled;
}
